import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import MedicationsTable from './components/MedicationsTable'
import { intersection } from "lodash";

class MedicationsTab extends Component {
  render() {
    const { resident, permissions, organization } = this.props;

    return (
      <div>
        <>
          <div className="d-flex justify-content-end pb-3">
            {
              organization.medlogs &&
              intersection(permissions, ["use_client_profile"]).length > 0 &&
              <Button
                href={`/organizations/${organization.name}/residents/${resident.id}/medication_log_entries`}>
                View {resident.first_name}'s Medlog
              </Button>
            }
          </div>
          <MedicationsTable
            editMedication={this.props.editMedication}
            refillMedication={this.props.refillMedication}/>
          <div className="d-flex justify-content-center">
            {
              this.props.action === "edit" &&
              <Button
                variant="link"
                onClick={() => {
                  this.props.newMedication();
                }}>
                Add Medication
              </Button>
            }
            
          </div>
        </>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    action: state.ui.action,
    organization: state.organization,
    resident: state.resident,
    permissions: state.permissions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    newMedication: () => {
      dispatch({
        type: "NEW_RESOURCE",
        payload: { resourceName: "medication" }
      })
    },
    editMedication: (resource) => {
      dispatch({
        type: "EDIT_RESOURCE",
        payload: {
          resourceName: "medication",
          resource
        }
      })
    },
    refillMedication: (resource) => {
      dispatch({
        type: "EDIT_RESOURCE",
        payload: {
          resourceName: "refill",
          resource
        }
      });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MedicationsTab)
